import { Action } from 'redux'
import { CalendarActions } from '../../../reducers/bookingCalendar/actionNames'

const requestToggleSummary = (): IRequestToggleSummary => ({
  type: CalendarActions.RequestToggleSummary,
})

export type IRequestToggleSummary = Action<CalendarActions.RequestToggleSummary>

const toggleSummary = (show: boolean): IToggleSummary => ({
  showSummary: show,
  type: CalendarActions.ToggleSummary,
})

export { requestToggleSummary, toggleSummary }

export interface IToggleSummary extends Action<CalendarActions.ToggleSummary> {
  showSummary: boolean
}
